import React from "react";
import { useSelector } from "react-redux";
import { bool, shape, string } from "prop-types";
import get from "lodash/get";

import { Link } from "@quintype/components";
import { UserFallbackIcon } from "../../../arrow/components/Svgs/user-fallback-icon";
import { getCategoryAndSubCategory, getTemplateName } from "../../../ga-utils";

import "./ProfileCard.m.css";

const ProfileCard = ({
  customStyleName,
  entityData,
  showRanking = true,
  cdnImage,
  isSsr,
  storyPage = false,
  linkCategory,
  position,
  story = {},
  config = {},
  isRankingDetail = false,
  eventAction,
  trendingPeople = false,
  disableLink = false,
}) => {
  const profileImgKey = trendingPeople ? entityData["photo-s3-key"] : get(entityData, ["photo", "0", "key"], "");
  const profileImgUrl = `${cdnImage}/${profileImgKey}?w=261&q=70`;
  const { name, designation, entityType } = entityData;

  const pageType = useSelector((state) => get(state, ["qt", "pageType"], {}));
  if (!profileImgUrl) return null;

  let isTracking = false;

  const handleProfileWidgetClick = () => {
    if (isTracking) return;
    isTracking = true;

    setTimeout(() => {
      isTracking = false;
    }, 300);

    const rankingEvent = isRankingDetail ? "dl_ranking_detail_interactions" : "dl_ranking_list_click";
    const rankingtemplate = isRankingDetail ? "rankdetail" : "listing";
    let templateName;
    const isWidget = ["home-page", "story-page"].includes(pageType);
    if (pageType === "story-page") {
      templateName = getTemplateName(story?.["story-template"]);
    } else if (pageType === "home-page") {
      templateName = getTemplateName(pageType);
    } else {
      templateName = rankingtemplate;
    }
    if (typeof window !== "undefined" && window.dataLayer) {
      const { category, subCategory, contentId } = getCategoryAndSubCategory(window.location, pageType, config, story);
      window.dataLayer.push({
        event: isWidget ? "dl_ranking_widget_click" : rankingEvent,
        link_text: name.toLowerCase(),
        link_position: position,
        link_category: linkCategory?.toLowerCase() || subCategory,
        category,
        sub_category: subCategory,
        content_id: contentId,
        template_name: templateName,
        platform: window.innerWidth >= 768 ? "desktop" : "mobile",
      });
    }
  };

  const profileCard = (
    <div styleName={`profile-card ${customStyleName}`}>
      {profileImgKey ? (
        <div styleName="image-wrapper">
          <img
            src={profileImgUrl}
            alt={designation ? `${name} - ${designation}` : name}
            title={designation ? `${name} - ${designation}` : name}
            width="261"
            height="261"
            {...(storyPage ? { loading: "lazy" } : {})}
          />
        </div>
      ) : (
        <UserFallbackIcon />
      )}
      {showRanking && !trendingPeople && <span styleName="ranking">{entityData["current-rank"]}</span>}
      <div styleName="description">
        <div styleName={`profile-card ${storyPage ? "profile-card-name-storypage" : ""}`} className="profile-card-name">
          {name}
        </div>
      </div>
    </div>
  );

  if (disableLink) return profileCard;

  return (
    // slug not avilable in snapshot data - linkTo is pending.
    <Link
      href={`/people/${
        entityData["most-powerful-women-snapshot-individual"]?.slug ||
        entityData["forty-under-forty-snapshot-individual"]?.slug ||
        entityData.slug
      }`}
      disableAjaxLinks={true}
      onMouseDown={handleProfileWidgetClick}
      onTouchStart={handleProfileWidgetClick}
    >
      {profileCard}
    </Link>
  );
};

ProfileCard.defaultProps = {
  customStyleName: "",
  showRanking: true,
  cardData: {},
};

ProfileCard.propTypes = {
  customStyleName: string,
  showRanking: bool,
  storyPage: bool,
  trendingPeople: bool,
  disableLink: bool,
  cardData: shape({
    rank: string,
    profileImg: string,
    linkTo: string,
    name: string,
    designation: string,
  }).isRequired,
};

export default ProfileCard;
